import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncateLinesDirective } from './truncate-lines.pipe';

@NgModule({
  declarations: [TruncateLinesDirective],
  imports: [CommonModule],
  exports: [TruncateLinesDirective],
  providers: [],
})
export class TurncatePipeModule {}
